import { render, staticRenderFns } from "./modalPresence.vue?vue&type=template&id=015c358b&scoped=true"
import script from "./modalPresence.vue?vue&type=script&lang=js"
export * from "./modalPresence.vue?vue&type=script&lang=js"
import style0 from "./modalPresence.vue?vue&type=style&index=0&id=015c358b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015c358b",
  null
  
)

export default component.exports